import React from 'react';
import { usePage, Link } from '@inertiajs/react';

const MenuOverlay = ({ isOpen, onClose }) => {
    const { auth } = usePage().props;

    return (
        <div className={`menu-overlay ${isOpen ? 'active' : ''}`}>
            <div className="menu-content">
                <div className="menu-left">
                    <nav className="menu-nav">
                        <a href="/virtual-tour" className="menu-link md:hidden" onClick={onClose}>Virtual Tour</a>
                        <a href="/#property" className="menu-link" onClick={onClose}>Our Community</a>
                        <a href="/#amenities" className="menu-link" onClick={onClose}>Care Services</a>
                        <a href="/#gallery" className="menu-link" onClick={onClose}>
                            Gallery <span className="dot"></span>
                        </a>

                        <a href="/contact" className="menu-link" onClick={onClose}>Contact Us</a>
                        <a href="/about" className="menu-link" onClick={onClose}>About Us</a>
                        <a href="/blogs" className="menu-link" onClick={onClose}>Blogs</a>
                    </nav>
                </div>

                <div className="menu-center">
                    <nav className="menu-nav-secondary">
                        <a href="/contact" className="menu-link-secondary" onClick={onClose}>Schedule a Tour</a>
                        <a href="/virtual-tour" className="menu-link-secondary hidden md:block" onClick={onClose}>Virtual Tour</a>

                        {auth.user ? (
                            <>
                                {auth.user.role === 'admin' && (
                                    <Link href="/dashboard" className="menu-link-secondary" onClick={onClose}>Admin Dashboard</Link>
                                )}
                                <Link href="/profile" className="menu-link-secondary" onClick={onClose}>My Profile</Link>
                                <Link
                                    href="/logout"
                                    method="post"
                                    as="button"
                                    className="menu-link-secondary text-left w-full"
                                    onClick={onClose}
                                >
                                    Log Out
                                </Link>
                            </>
                        ) : (
                            <>
                                <Link href="/login" className="menu-link-secondary" onClick={onClose}>Log In</Link>
                                <Link href="/register" className="menu-link-secondary" onClick={onClose}>Register</Link>
                            </>
                        )}

                        <a href="/contact" className="menu-link-green" onClick={onClose}>Apply Now →</a>
                    </nav>
                </div>

                <div className="menu-right">
                    <div className="newsletter-card">
                        <h3>STAY<br />CONNECTED</h3>
                        <p>Get updates about our community, upcoming events, and learn more about our caring environment at Hollywood Royale Garden</p>
                        <button className="newsletter-btn" onClick={onClose}>Stay Updated →</button>
                    </div>
                </div>
            </div>

            <div className="menu-bottom">
                <button className="menu-bottom-btn" onClick={() => { window.location.href = '/contact'; onClose(); }}>
                    <i className="fas fa-phone"></i> Contact Us →
                </button>
            </div>
        </div>
    );
};

export default MenuOverlay;
